<template>
    <nav class="woocommerce-breadcrumb" aria-label="Breadcrumb">
        <NuxtLink :to="getLangUrl('', baseUrl, locale)" aria-label="Home">Home</NuxtLink>
        <template v-if="breadCrumb.parentCategory">
            &nbsp;/&nbsp;
            <NuxtLink :to="getLangUrl(`product-category/${breadCrumb.parentCategory.slug}`, baseUrl, locale)" aria-label="Product Category">{{htmlSpecialcharsDecode(breadCrumb.parentCategory.name)}}</NuxtLink>
            
        </template>
        <template v-if="breadCrumb.childCategory">
            &nbsp;/&nbsp;
            <NuxtLink :to="getLangUrl(`product-category/${breadCrumb.childCategory.slug}`, baseUrl, locale)" aria-label="Product Category">{{htmlSpecialcharsDecode(breadCrumb.childCategory.name)}}</NuxtLink>
        </template>
        &nbsp;/&nbsp;{{  htmlSpecialcharsDecode(productTitle)  }}
    </nav>
</template>

<script setup lang="ts">
    const props = defineProps(["data", "name"]);
    const breadCrumb = computed(() => props.data);

    const productTitle = computed(() => props.name);
    const runtimeConfig = useRuntimeConfig();

    const baseUrl = runtimeConfig.public.BASE_URL;
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';
</script>

<style lang="scss">
    @import "@/assets/scss/components/product/_breadcrumb.scss";
</style>